var React = require('react');

function Document (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.2 5h7.68a1 1 0 011 1v12.5a1 1 0 01-1 1H7a1 1 0 01-1-1V8.95L10.2 5zm5.058 7.044H9.623a.604.604 0 000 1.207h5.635a.604.604 0 100-1.207zm-5.635 2.918a.604.604 0 000 1.207h2.817a.604.604 0 000-1.207H9.623zm.89-7.905L7.891 9.732h2.316a.305.305 0 00.304-.305v-2.37z"}));
}

Document.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25"};

module.exports = Document;

Document.default = Document;
